import React, { useImperativeHandle, forwardRef, useRef } from "react";
import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import "./stripe.css";
import styles from "./CreditCardForm.module.scss";
import creditCard from "../../assets/images/card-bg.png";

import { stripePromise, stripeTokenHandler } from "../../utils/stripe.utils";

export const WrappedCardElement = () => {
  return (
    <CardElement
      className="card-element"
      options={{
        style: {
          base: {
            height: "50px",
            fontSize: "16px",
            lineHeight: "32px",
            fontFamily: "'Hind', sans-serif",
            color: "#424770",
            "::placeholder": {
              color: "#8888B5",
            },
          },
          invalid: {
            color: "#9E2146",
          },
        },
      }}
    />
  );
};

export const ForwardedCardElement = forwardRef(function ForwardedCardElement(_, ref) {
  const stripe = useStripe();
  const elements = useElements();

  const submitCreditCardToStripe = async (failOnEmptyCard = true) => {
    try {
      if (!stripe || !elements) throw new Error("Stripe failed to load");

      const card = elements.getElement(CardElement);

      if (card._empty && !failOnEmptyCard) return { cardSaved: false };

      const { error, token } = await stripe.createToken(card);
      if (error) throw error;

      await stripeTokenHandler(token);

      return { cardSaved: true };
    } catch (error) {
      throw error;
    }
  };

  useImperativeHandle(ref, () => ({
    submitCreditCardToStripe,
  }));

  return <WrappedCardElement />;
});

export const AddCardInput = forwardRef(function AddCardInput(_, ref) {
  const forwardedCardElementRef = useRef(null);

  useImperativeHandle(ref, () => ({
    forwardedCardElementRef,
  }));

  return (
    <Elements stripe={stripePromise}>
      <ForwardedCardElement ref={forwardedCardElementRef} />
    </Elements>
  );
});

export const CreditCardCard = ({ card = {}, name }) => {
  const expMonth = card.exp_month ? String(card.exp_month).padStart(2, "0") : "••";
  const expYear = card.exp_year ? String(card.exp_year).slice(-2) : "••";
  return (
    <div className={`mb-4 ${styles.CreditCardCard}`} data-testid="CreditCardCard">
      <img className={styles.backdrop} src={creditCard} alt="" />
      <span className={styles.brand}>{card.brand || "ACME"}</span>
      <span className={styles.details}>•••• •••• •••• {card.last4 || "XXXX"}</span>
      <span className={styles.name}>{name || "John Doge"}</span>
      <span className={styles.date}>
        {expMonth}/{expYear}
      </span>
    </div>
  );
};
